const CheckIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 16.061 11.502">
            <path
                id="Path_3487"
                data-name="Path 3487"
                d="M7674.756,5108.606l-3.75,3.75-6.162,6.162-5.088-5.089"
                transform="translate(-7659.226 -5108.076)"
                fill="none"
                stroke="var(--icon-color)"
                strokeWidth="1.5"
            />
        </svg>
    );
};

export default CheckIcon;
